
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_PO_LIST, BULK_APPROVE_PO, GET_STAKEHOLDER_CATEGORY, SEND_BACK_FOR_MODIFICATION, APPROVE_MODIFIED_PO, SEND_PO_TO_SAP } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { Container, Button, Box, Card, Stack, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Send as SendIcon } from '@mui/icons-material';
import apiClient from "../../../axios";

function ServicePoApproval() {

  const navigate = useNavigate();
  const { state } = useLocation();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [stakeholderDetails, setStakeholderDetails] = useState({});
  const [poListData, setPoListData] = useState();
  const [bulkApprovePo, setbulkApprovePo] = useState();
  const [poForModificationList, setPoForModificationList] = useState([]);
  const [poList, setpoList] = useState([]);
  const [sendToSapList, setSendToSapList] = useState([]);
  const [tabValue, setTabValue] = useState(state?.tabVal ? state?.tabVal : "0");
  const [tabValueModify, setTabValueModify] = useState(state?.tabValueModify ? state?.tabValueModify : "false");
  const [poModifyForApproval, setPoModifyForApproval] = useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [confirmOpen3, setConfirmOpen3] = useState(false);
  const handleConfirmOpen3 = () => setConfirmOpen3(true);
  const handleConfirmClose3 = () => setConfirmOpen3(false);

  const [confirmOpen4, setConfirmOpen4] = useState(false);
  const handleConfirmOpen4 = () => setConfirmOpen4(true);
  const handleConfirmClose4 = () => setConfirmOpen4(false);

  const [confirmOpen5, setConfirmOpen5] = useState(false);
  const handleConfirmOpen5 = () => setConfirmOpen5(true);
  const handleConfirmClose5 = () => setConfirmOpen5(false);


  useEffect(() => {
    getPoList();
    getStakeDetails();
  }, [tabValue, tabValueModify]);


  function getStakeDetails() {
    if (decoded.extension_URN) {
      loaderService.showLoader()
      apiClient
        .post(GET_STAKEHOLDER_CATEGORY,
          {
            "urn": decoded.extension_URN,
            "type": ""
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setStakeholderDetails(response.data);

          loaderService.hideLoader()
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader()
          toast.error(error.message);
        });
    }
  }

  const getPoList = () => {
    loaderService.showLoader();

    let payload = {
      "poType": "SO",
      "approvalStatus": tabValue === '2' ? '1' : tabValue,
      "isModifiedPoQuantityApproved": tabValue === '2' ? tabValueModify : '',
    };

    if (tabValue === '3') {
      payload = {
        "poType": "SO",
        "approvalStatus": 1,
        "isSapPOAdded": false,
      };
    }

    if (tabValue === '4') {
      payload = {
        "poType": "SO",
        "approvalStatus": 1,
        "isSapPOAdded": true,
      };
    }

    apiClient
      .post(GET_PO_LIST,
        payload,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setPoListData(response.data?.poDetailsList || []);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onViewDetails = (cellValues) => {
    navigate('./soDetails', {
      state: { selectedRow: cellValues.row, screen: "ApprovalList", tabVal: tabValue, tabValueModify: tabValueModify }
    });
  }

  const columns = [
    { field: 'poNumber', headerName: 'SO No.', width: 120 },
    { field: 'planningNumber', headerName: 'Planning Number', width: 200 },
    { field: 'poStakeholderUrn', headerName: "Stakeholder URN", width: 150 },
    { field: 'poStakeholderName', headerName: "Stakeholder Name", width: 150 },
    { field: 'poQuantity', headerName: 'Quantity', width: 160 },
    { field: 'grnQuantity', headerName: 'Received Quantity', width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: 'SO Balance Quantity (MT)', width: 150 },
    { field: 'scheduledQuantity', headerName: 'Scheduled Quantity (MT)', width: 150 },
    {
      field: "approvedOn",
      headerName: "Approved On",
      type: "dateTime",
      width: 200,
      valueGetter: (params) =>
        params.value ? new Date(params.value) : null,
    },
    { field: 'approvedBy', headerName: 'Approved By', width: 200 },
    {
      field: 'poStatus', headerName: 'Status', width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: "Current Owner", width: 150, hide: decoded.extension_URN, },
    { field: 'sapVendorId', headerName: "SAP Vendor ID", width: 150 },
    {
      field: 'Action', width: 120,
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => onViewDetails(cellValues)}
          >
            View
          </Button>
        );
      }
    },

  ];

  const columns1 = [
    { field: 'poNumber', headerName: 'SO No.', width: 120 },
    { field: 'planningNumber', headerName: 'Planning Number', width: 200 },
    { field: 'poStakeholderUrn', headerName: "Stakeholder URN", width: 150 },
    { field: 'poStakeholderName', headerName: "Stakeholder Name", width: 150 },
    { field: 'poQuantity', headerName: 'Quantity', width: 160 },
    { field: 'modifiedPoQuantity', headerName: 'Modified Quantity (MT)', width: 170, hide: tabValue !== "3" && tabValue !== "4"},
    { field: 'grnQuantity', headerName: 'Received Quantity', width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: 'SO Balance Quantity (MT)', width: 150 },
    { field: 'scheduledQuantity', headerName: 'Scheduled Quantity (MT)', width: 150 },
    {
      field: "approvedOn",
      headerName: "Approved On",
      type: "dateTime",
      width: 200,
      valueGetter: (params) =>
        params.value ? new Date(params.value) : null,
    },
    { field: 'approvedBy', headerName: 'Approved By', width: 200 },
    {
      field: 'poStatus', headerName: 'Status', width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: "Current Owner", width: 150, hide: decoded.extension_URN, },
    { field: 'sapVendorId', headerName: "SAP Vendor ID", width: 150 },
    { field: 'sapPoNumber', headerName: "SAP PO Number", width: 150, hide: tabValue !== "4" },
    {
      field: 'Action', width: 120,
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => onViewDetails(cellValues)}
          >
            View
          </Button>
        );
      }
    },

  ];

  const modifyPoCol = [
    { field: 'poNumber', headerName: 'SO No.', width: 120 },
    { field: 'planningNumber', headerName: 'Planning Number', width: 130 },
    { field: 'poStakeholderUrn', headerName: "Stakeholder URN", width: 130 },
    { field: 'poStakeholderName', headerName: "Stakeholder Name", width: 150 },
    { field: 'poQuantity', headerName: 'SO Quantity', width: 100 },
    { field: 'grnQuantity', headerName: "Received Quantity", width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: 'SO Balance Quantity (MT)', width: 150 },
    { field: 'scheduledQuantity', headerName: "Scheduled Quantity (MT)", width: 150 },
    { field: 'modifiedPoQuantity', headerName: 'Modified SO Quantity (MT)', width: 150 },
    {
      field: "modifiedPoQuantityApprovedOn",
      headerName: "Approved On",
      type: "dateTime",
      width: 200,
      valueGetter: (params) =>
        params.value ? new Date(params.value) : null,
    },
    { field: 'modifiedPoQuantityApprovedBy', headerName: 'Approved By', width: 200 },
    {
      field: 'poStatus', headerName: 'Status', width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: "Current Owner", width: 150, hide: decoded.extension_URN, },
    // { field: 'destinationStakeholderType', headerName: 'Destination Stakeholder Type', width: 130 },
    // { field: 'destinationStakeholderUrn', headerName: 'Destination Stakeholder URN', width: 130 },
    // {
    //   field: 'isApproved', headerName: 'Status', width: 90, hide: decoded.extension_URN,
    //   renderCell: (params) => {
    //     return params.row.isApproved === 1 ? "Approved" : "Pending"
    //   }
    // },
    // { field: 'owner', headerName: 'Current Owner', width: 150, hide: decoded.extension_URN, },
    { field: 'sapVendorId', headerName: "SAP Vendor ID", width: 150 },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Button variant="contained"
            color="primary"
            onClick={() => onViewDetails(cellValues)}
          >
            View
          </Button>
        );
      }
    },

  ];

  const onConfirmApprove = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await toApproveBulk(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen(false);
      setIsApiCalled(false);
    }
  };

  const onApproveButtonClick = () => {
    handleConfirmOpen();
  }

  const onConfirmReject = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await toApproveBulk(false);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen2(false);
      setIsApiCalled(false);
    }
  };

  const onRejectButtonClick = () => {
    handleConfirmOpen2();
  }

  const toApproveBulk = async (approval) => {
    loaderService.showLoader();
    return await apiClient
      .post(BULK_APPROVE_PO,
        {
          "poNumberList":
            poList
          ,
          "isApproved": approval,
          "approvedBy": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setbulkApprovePo(response.data);
        getPoList();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (bulkApprovePo) {
      if (bulkApprovePo.isSuccess === true) {
        toast.success(bulkApprovePo?.message)
      }
      else {
        toast.error(bulkApprovePo?.message ? bulkApprovePo?.message : "Error")
      }
    }
  }, [bulkApprovePo]);

  const onApproveModified = (e) => {
    if (poModifyForApproval?.length === 0) {
      toast.error("Select atleast one SO to Approve")
    }
    else {
      onApproveModifiedButtonClick(e);
    }
  }

  const onConfirmApproveModifiedPO = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await approveModifiedPO();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen4(false);
      setIsApiCalled(false);
    }
  };

  const onApproveModifiedButtonClick = () => {
    handleConfirmOpen4();
  }

  const approveModifiedPO = async (e) => {
    loaderService.showLoader();
    return await apiClient
      .post(APPROVE_MODIFIED_PO,
        {
          "poNumberList": poModifyForApproval,
          "isModifiedPoQuantityApproved": true,
          "modifiedPoQuantityApprovedBy": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        toast.success(response.data.message)
        getPoList();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const handleTabChange = (e, newValue) => {
    e.preventDefault();
    setTabValue(newValue);
    setTabValueModify("false");
    setpoList([]);
    setPoForModificationList([]);
    setPoModifyForApproval([]);
    setSendToSapList([]);
  }

  const handleModifyTabChange = (e, newValue) => {
    e.preventDefault();
    setTabValueModify(newValue);
    setPoModifyForApproval([])
  }

  const onConfirmModify = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await onSendForModification();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen3(false);
      setIsApiCalled(false);
    }
  };

  const onSendtoModifyButtonClick = () => {
    handleConfirmOpen3();
  }

  const onSendForModification = async () => {
    loaderService.showLoader();
    return await apiClient
      .post(SEND_BACK_FOR_MODIFICATION,
        {
          "poNumbers": poForModificationList
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        if (response.data?.isSuccess === true) {
          toast.success(response.data?.message)
          getPoList();
        }
        else {
          toast.error(response.data?.message ? response.data?.message : "Error")
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getSelectedPoNumbers = (newSelection) => {
    return newSelection.map(row => {
      let pNo = "";
      poListData.forEach(po => {
        if (row === po.id) {
          pNo = po.poNumber;
        }
      });
      return pNo;
    });
  };

  const onConfirmSendToSapPO = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await ReadyToSendToSap(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen5(false);
      setIsApiCalled(false);
    }
  };

  const onSendToSap = () => {
    handleConfirmOpen5();
  }

  const ReadyToSendToSap = async () => {
    loaderService.showLoader();
    return await apiClient
      .post(SEND_PO_TO_SAP,
        {
          "poNumberList": sendToSapList,
          "isApproved": true,
          "approvedBy": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        if (response.data?.isSuccess === true) {
          toast.success(response.data?.message)
          getPoList();
          setSendToSapList([]);
        }
        else {
          toast.error(response.data?.message ? response.data?.message : "Error")
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT54</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Service PO Approval
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            {!(stakeholderDetails?.category === 'Grower') &&
              <>
                <Stack direction="row" spacing={1}>
                  <Button variant="contained" hidden={tabValue !== '0'} disabled={poList?.length < 1} onClick={(e) => onApproveButtonClick(e)} startIcon={<ApproveIcon />}>
                    Approve
                  </Button>
                  <Button variant="contained" hidden={tabValue !== '0'} disabled={poList?.length < 1} onClick={(e) => onRejectButtonClick(e)} startIcon={<CancelIcon />}>
                    Reject
                  </Button>
                  <Button variant="contained" hidden={tabValue !== '1'} disabled={poForModificationList?.length < 1} onClick={(e) => onSendtoModifyButtonClick(e)} startIcon={<SendIcon />}>
                    Send for Modification
                  </Button>
                  <Button variant="contained" sx={{ minWidth: 100 }} disabled={poListData?.length < 1 || tabValueModify === "true"} hidden={tabValue !== '2'} onClick={(e) => onApproveModified(e)} startIcon={<ApproveIcon />}>
                    Approve Modified SO
                  </Button>
                  <Button
                    variant="contained"
                    hidden={tabValue !== '3'}
                    disabled={sendToSapList?.length < 1}
                    onClick={onSendToSap}
                    startIcon={<SendIcon />}
                  >
                    Send To SAP
                  </Button>
                </Stack>
              </>
            }
          </Stack>
        </Stack>
        <Card>
          <TabContext value={tabValue} >
            <Box sx={{
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: "whitesmoke",
              '& .MuiTab-root': {
                minWidth: { xs: 140, sm: 160 },
                textTransform: 'none',
                fontSize: { xs: '0.85rem', sm: '0.95rem' }
              }
            }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                <Tab label="Service PO Approval List" value="0" />
                <Tab label="Service PO Approved List" value="1" />
                <Tab label="Modified Service PO" value="2" />
                <Tab label="Ready to Send to SAP" value="3" />
                <Tab label="Sent to SAP" value="4" />
              </TabList>
            </Box>
            <TabPanel value="0">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  poListData &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    rows={poListData}
                    columns={columns}
                    pageSize={10}
                    initialState={{
                      sorting: {
                        sortModel: [
                          {
                            field: "createdOn",
                            sort: "desc", // latest first
                          },
                        ],
                      },
                    }}
                    checkboxSelection
                    isRowSelectable={(params) => {
                      const sapVendorId = params?.row?.sapVendorId;
                      return sapVendorId !== null && sapVendorId !== undefined && String(sapVendorId).trim() !== "";
                    }}
                    components={{ Toolbar: QuickSearchToolbar }}
                    onSelectionModelChange={(newSelection) => {
                      setpoList(getSelectedPoNumbers(newSelection));
                    }}
                  />
                }
              </Box>
            </TabPanel>
            <TabPanel value="1">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  poListData &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    rows={poListData}
                    columns={columns1}
                    initialState={{
                      sorting: {
                        sortModel: [
                          {
                            field: "approvedOn",
                            sort: "desc", // latest first
                          },
                        ],
                      },
                    }}
                    pageSize={10}
                    checkboxSelection
                    components={{ Toolbar: QuickSearchToolbar }}
                    isRowSelectable={(params) => !params.row.isSentBackForModification === true || (params.row.isShortClosed === true && params.row.isModifiedPoQuantityApproved === true)}
                    // isRowSelectable={(params) => params.row.isShortClosed === true && params.row.isModifiedPoQuantityApproved === true}
                    onSelectionModelChange={(newSelection) => {
                      setPoForModificationList(getSelectedPoNumbers(newSelection));
                    }}
                  />
                }
              </Box>
            </TabPanel>
            <TabPanel value="2">
              <Card>
                <TabContext value={tabValueModify}>
                  <Box sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    bgcolor: "whitesmoke",
                    '& .MuiTab-root': {
                      minWidth: { xs: 140, sm: 160 },
                      textTransform: 'none',
                      fontSize: { xs: '0.85rem', sm: '0.95rem' }
                    }
                  }}>
                    <TabList onChange={handleModifyTabChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                      <Tab label='Pending Modified SO List' value="false" />
                      <Tab label='Approved Modified SO List' value="true" />
                    </TabList>
                  </Box>

                  <TabPanel value="false" >
                    <Box style={{ height: 500, width: '100%' }} >
                      {
                        poListData &&
                        <DataGrid
                          sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                          }}
                          getRowHeight={() => 'auto'}
                          getRowId={(row) => row.id}
                          rows={poListData}
                          columns={modifyPoCol}
                          pageSize={10}
                          initialState={{
                            sorting: {
                              sortModel: [
                                {
                                  field: "modifiedPoQuantityApprovedOn",
                                  sort: "desc", // latest first
                                },
                              ],
                            },
                          }}
                          components={{ Toolbar: QuickSearchToolbar }}
                          checkboxSelection={!decoded.extension_URN}
                          onSelectionModelChange={(newSelection) => {
                            setPoModifyForApproval(getSelectedPoNumbers(newSelection));
                          }}
                        />
                      }

                    </Box>
                  </TabPanel>
                  <TabPanel value="true" >
                    <Box style={{ height: 500, width: '100%' }} >
                      {
                        poListData &&
                        <DataGrid
                          sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                          }}
                          getRowHeight={() => 'auto'}
                          getRowId={(row) => row.id}
                          rows={poListData}
                          columns={modifyPoCol}
                          pageSize={10}
                          initialState={{
                            sorting: {
                              sortModel: [
                                {
                                  field: "modifiedPoQuantityApprovedOn",
                                  sort: "desc", // latest first
                                },
                              ],
                            },
                          }}
                          components={{ Toolbar: QuickSearchToolbar }}

                        />
                      }

                    </Box>
                  </TabPanel>
                </TabContext>
              </Card>
            </TabPanel>
            <TabPanel value="3">
              <Box style={{ height: 445, width: '100%' }}>
                {poListData &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    rows={poListData}
                    columns={columns1}
                    pageSize={10}
                    initialState={{
                      sorting: {
                        sortModel: [
                          {
                            field: "approvedOn",
                            sort: "desc",
                          },
                        ],
                      },
                    }}
                    checkboxSelection
                    isRowSelectable={(params) => {
                      const sapVendorId = params?.row?.sapVendorId;
                      return sapVendorId !== null && sapVendorId !== undefined && String(sapVendorId).trim() !== "";
                    }}
                    components={{ Toolbar: QuickSearchToolbar }}
                    onSelectionModelChange={(newSelection) => {
                      setSendToSapList(getSelectedPoNumbers(newSelection));
                    }}
                  />
                }
              </Box>
            </TabPanel>

            <TabPanel value="4">
              <Box style={{ height: 445, width: '100%' }}>
                {poListData &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    rows={poListData}
                    columns={columns1}
                    pageSize={10}
                    initialState={{
                      sorting: {
                        sortModel: [
                          {
                            field: "approvedOn",
                            sort: "desc",
                          },
                        ],
                      },
                    }}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
            </TabPanel>
          </TabContext>
        </Card>

      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject" />
      <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmModify} onClose={handleConfirmClose3} action="Send for Modification" />
      <ConfirmationPopover onOpen={confirmOpen4} onConfirm={onConfirmApproveModifiedPO} onClose={handleConfirmClose4} action="Approve Modified SO" />
      <ConfirmationPopover onOpen={confirmOpen5} onConfirm={onConfirmSendToSapPO} onClose={handleConfirmClose5} action="Send to SAP" />

    </>
  );
}
export default ServicePoApproval;
